import type React from 'react'

import { Button } from 'ui/Button/Button'

type Props = {
  onClose: () => void
}

export const InstallAppAlert: React.FC<Props> = ({ onClose }) => {
  return (
    <div className="w-96">
      <div className="text-center">
        <h1 className="block text-2xl font-bold text-gray-800">Let's Install Presync</h1>
      </div>

      <div className="mt-5 text-sm text-center">
        <p className="mb-2">You have to use Presync app to be able to install plugins</p>
      </div>
      <div className="mt-5 text-center gap-x-3">
        <Button onClick={() => window.open('https://presync.io', '_blank')}>Visit Presync.io</Button>{' '}
        <Button outline="ghost" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
